import { CriteriaType } from '@shared/models';

export enum IntuitiveCriteriaPropertyStatus {
  Property,
  NoProperty,
  Both,
}

export interface OutcomeDetailsCardV2 {
  issue: string;
  context: string | undefined;
  criteriaType: CriteriaType;
  questionsAndAnswers: {
    question: string | undefined;
    answer: string | undefined;
    answerUnits: string | undefined;
  }[];
}
